import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Box, Typography, Grid, Paper, Chip, Divider } from "@mui/material";
import { CATEGORIES } from "./CategoryPage";
import { TAG_CONFIG } from "../pages/TagPage";
import axios from "axios";

const CATEGORY_META = {
  "latina-cam-girls":          { emoji: "🌶️", gradient: "linear-gradient(135deg,#f093fb,#f5576c)",   label: "Latina" },
  "blonde-cam-girls":          { emoji: "👱‍♀️", gradient: "linear-gradient(135deg,#ffecd2,#fcb69f)",   label: "Blonde" },
  "brunette-cam-girls":        { emoji: "🌸",  gradient: "linear-gradient(135deg,#a18cd1,#fbc2eb)",   label: "Brunette" },
  "milf-cam-girls":            { emoji: "🔥",  gradient: "linear-gradient(135deg,#ff9a9e,#fad0c4)",   label: "MILF" },
  "teen-cam-girls":            { emoji: "✨",  gradient: "linear-gradient(135deg,#a1c4fd,#c2e9fb)",   label: "Teen 18+" },
  "ebony-cam-girls":           { emoji: "♠️",  gradient: "linear-gradient(135deg,#667eea,#764ba2)",   label: "Ebony" },
  "asian-cam-girls":           { emoji: "🌺",  gradient: "linear-gradient(135deg,#f6d365,#fda085)",   label: "Asian" },
  "mature-cam-girls":          { emoji: "👑",  gradient: "linear-gradient(135deg,#84fab0,#8fd3f4)",   label: "Mature" },
  "french-cam-girls":          { emoji: "🇫🇷", gradient: "linear-gradient(135deg,#003082,#EF4135)",   label: "French" },
  "bbw-cam-girls":             { emoji: "💋",  gradient: "linear-gradient(135deg,#f093fb,#f5576c)",   label: "BBW" },
  "redhead-cam-girls":         { emoji: "🔥",  gradient: "linear-gradient(135deg,#f7971e,#ffd200)",   label: "Redhead" },
  "feet-cam-girls":            { emoji: "🦶",  gradient: "linear-gradient(135deg,#fddb92,#d1fdff)",   label: "Feet" },
  "roleplay-cam-girls":        { emoji: "🎭",  gradient: "linear-gradient(135deg,#e0c3fc,#8ec5fc)",   label: "Roleplay" },
  "bdsm-cam-girls":            { emoji: "⛓️",  gradient: "linear-gradient(135deg,#2c3e50,#fd746c)",   label: "BDSM" },
  "dominant-cam-girls":        { emoji: "👠",  gradient: "linear-gradient(135deg,#1a1a2e,#e94560)",   label: "Dominant" },
  "submissive-cam-girls":      { emoji: "🎀",  gradient: "linear-gradient(135deg,#ffecd2,#fcb69f)",   label: "Submissive" },
  "squirt-cam-girls":          { emoji: "💦",  gradient: "linear-gradient(135deg,#4facfe,#00f2fe)",   label: "Squirt" },
  "interactivetoy-cam-girls":  { emoji: "📳",  gradient: "linear-gradient(135deg,#43e97b,#38f9d7)",   label: "Interactive" },
  "voyeur-cam-girls":          { emoji: "👁️",  gradient: "linear-gradient(135deg,#30cfd0,#330867)",   label: "Voyeur" },
};

const DEFAULT_ORDER = [
  "latina-cam-girls","blonde-cam-girls","brunette-cam-girls","milf-cam-girls",
  "teen-cam-girls","ebony-cam-girls","asian-cam-girls","mature-cam-girls",
  "feet-cam-girls","roleplay-cam-girls","bdsm-cam-girls","interactivetoy-cam-girls",
  "squirt-cam-girls","dominant-cam-girls","voyeur-cam-girls",
];

// Popular tags shown below the category grid
const FEATURED_TAGS = ["feet","roleplay","bdsm","squirt","voyeur","dominant","submissive","interactivetoy"];

const CategoriesNav = () => {
  const [order, setOrder]       = useState(DEFAULT_ORDER);
  const [hotSlug, setHotSlug]   = useState(null); // most trending category

  useEffect(() => {
    // Fetch trending intelligence and reorder categories by demand
    axios.get(`${process.env.REACT_APP_API_URL}/api/trending-content?days=7`)
      .then(res => {
        const topCats = res.data?.top_categories;
        if (!topCats || topCats.length === 0) return;

        // Reorder: trending categories first, then rest, always keep top-cam-girls last
        const trending = topCats.filter(s => CATEGORY_META[s]);
        const rest = DEFAULT_ORDER.filter(s => !trending.includes(s));
        const newOrder = [...trending, ...rest];
        setOrder([...new Set(newOrder)]); // dedup
        setHotSlug(trending[0] || null);  // #1 trending gets HOT badge
      })
      .catch(() => {}); // silent fail — use default order
  }, []);

  return (
    <Box sx={{ mb: 4 }}>
      {/* Top row: section title + special links */}
      <Box sx={{ display:"flex", alignItems:"center", gap:1.5, mb:2, flexWrap:"wrap" }}>
        <Typography variant="h5" sx={{ fontWeight: 800 }}>Browse Categories</Typography>
        {hotSlug && (
          <Chip label="🔥 Updated by demand" size="small"
            sx={{ bgcolor:"#fff3e0", color:"#e65100", fontWeight:700, fontSize:"0.72rem" }} />
        )}
        {/* Top Rated shortcut */}
        <Chip
          label="🏆 Top Rated"
          component={Link} to="/top-rated" clickable
          sx={{ bgcolor:"#fffde7", color:"#f57f17", border:"1px solid #f9a825",
            fontWeight:700, fontSize:"0.75rem", "&:hover":{ bgcolor:"#f9a825", color:"#fff" } }}
        />
        {/* Spanish page shortcut */}
        <Chip
          label="🌶️ Latinas en Vivo"
          component={Link} to="/es/latinas-en-vivo" clickable
          sx={{ bgcolor:"#fff0f7", color:"#FF4196", border:"1px solid #FF4196",
            fontWeight:700, fontSize:"0.75rem", "&:hover":{ bgcolor:"#FF4196", color:"#fff" } }}
        />
      </Box>
      <Grid container spacing={1.5}>
        {order.map((slug) => {
          const meta = CATEGORY_META[slug];
          if (!meta) return null;
          const isTop     = slug === "top-cam-girls";
          const isHot     = slug === hotSlug;
          const href      = isTop ? "/top-cam-girls" : `/category/${slug}`;
          return (
            <Grid item xs={6} sm={4} md={3} key={slug}>
              <Paper
                component={Link} to={href}
                elevation={0}
                sx={{
                  display:"flex", flexDirection:"column",
                  alignItems:"center", justifyContent:"center",
                  p:2, borderRadius:2, cursor:"pointer",
                  background: meta.gradient,
                  textDecoration:"none", color:"#fff",
                  minHeight: 80, position:"relative",
                  transition:"transform 0.15s,box-shadow 0.15s",
                  "&:hover":{ transform:"translateY(-3px)", boxShadow:"0 8px 20px rgba(0,0,0,0.15)" },
                  ...(isHot && { boxShadow:"0 0 0 3px #FF4196, 0 4px 16px rgba(255,65,150,0.4)" }),
                }}
              >
                {isHot && (
                  <Box sx={{ position:"absolute", top:6, right:8,
                    bgcolor:"#FF4196", borderRadius:"10px", px:0.8, py:0.2,
                    fontSize:"0.62rem", fontWeight:900, letterSpacing:0.5 }}>
                    🔥 HOT
                  </Box>
                )}
                <Typography sx={{ fontSize:"1.8rem", mb:0.5 }}>{meta.emoji}</Typography>
                <Typography sx={{ fontWeight:800, fontSize:"0.85rem", textAlign:"center" }}>
                  {meta.label}
                </Typography>
              </Paper>
            </Grid>
          );
        })}
      </Grid>

      {/* Tag chips row */}
      <Box sx={{ mt: 3 }}>
        <Divider sx={{ mb: 2 }} />
        <Box sx={{ display:"flex", alignItems:"center", gap:1, flexWrap:"wrap" }}>
          <Typography variant="body2" sx={{ fontWeight:700, color:"#888", mr:0.5 }}>
            🏷️ Browse by tag:
          </Typography>
          {FEATURED_TAGS.map((t) => {
            const tc = TAG_CONFIG[t];
            if (!tc) return null;
            return (
              <Chip
                key={t}
                label={`${tc.emoji} #${tc.label}`}
                component={Link} to={`/tag/${t}`} clickable
                size="small"
                sx={{ bgcolor:"#f0f0ff", color:"#5c35d0", border:"1px solid #a78bfa",
                  fontWeight:700, fontSize:"0.75rem",
                  "&:hover":{ bgcolor:"#5c35d0", color:"#fff" } }}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default CategoriesNav;
